module.exports = __webpack_public_path__ + "static/media/cobot.73de8041.jpg";